export class CustomFilterModel {
    Id: number;
    Name: string;
    SerializedFilter: string;

    constructor() {

    }
}